import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    orderList: []
  },
  getters: {
    waitingOrders: state => state.orderList.filter(o => !o.deliveredAt)
  },
  mutations,
  actions
}
